import { TFunction } from 'i18next';

import { CryptoPayoutPaymentMethod, CryptoPayoutStatus } from 'types/cryptoPayout';

import LABELS from './keys';

export interface FormatStatusLabelParams {
  status: CryptoPayoutStatus;
  currentStatus: CryptoPayoutStatus;
  cryptoCurrencyCode: string | null;
  method: CryptoPayoutPaymentMethod | null;
  t: TFunction;
}

export const formatStatusLabel = ({ status, currentStatus, cryptoCurrencyCode, method, t }: FormatStatusLabelParams): string => {
  if (status === CryptoPayoutStatus.Submitted && cryptoCurrencyCode && method) {
    if (method === CryptoPayoutPaymentMethod.BinancePay) {
      return t(LABELS.STATUS_SUBMITTED_BINANCE_PAY, { asset: cryptoCurrencyCode });
    }

    return t(LABELS.STATUS_SUBMITTED_ONCHAIN, { asset: cryptoCurrencyCode });
  }

  if (
    status === CryptoPayoutStatus.Confirmed &&
    method === CryptoPayoutPaymentMethod.Onchain &&
    currentStatus === CryptoPayoutStatus.Submitted
  ) {
    return t(LABELS.STATUS_CONFIRMED_AWAITING);
  }

  return t(LABELS.STATUSES[status]);
};
